"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetCode = exports.HttpStatus = exports.Method = void 0;
var base_1 = require("../../base");
Object.defineProperty(exports, "Method", { enumerable: true, get: function () { return base_1.Method; } });
Object.defineProperty(exports, "HttpStatus", { enumerable: true, get: function () { return base_1.HttpStatus; } });
/**
 * 后台返回状态码
 */
var RetCode;
(function (RetCode) {
    RetCode[RetCode["SUCCESS"] = 0] = "SUCCESS";
})(RetCode || (RetCode = {}));
exports.RetCode = RetCode;
